/* eslint-disable no-console */

import { CallActionPayload, MethodResponse, UIStateCallback } from '../../types';
import { ContextAPI } from '../ImpactAiContextProvider';

export const debug = (
  payload: CallActionPayload,
  contextApi: ContextAPI,
  uiStateCallback?: UIStateCallback
): MethodResponse => {
  const { message = 'Impact AI Context Debug', includeTimestamp = true } = payload as {
    message?: string;
    includeTimestamp?: boolean;
  };

  if (uiStateCallback) {
    uiStateCallback('processing');
  }

  try {
    const fullContext = contextApi.getFullContext();

    const debugOutput = {
      message,
      ...(includeTimestamp && { timestamp: new Date().toISOString() }),
      contextKeys: Object.keys(fullContext),
      contextSize: Object.keys(fullContext).length,
      context: fullContext,
    };

    console.group(`🐛 ${message}`);

    if (includeTimestamp) {
      console.log(`⏰ Timestamp: ${debugOutput.timestamp}`);
    }

    console.log(`📊 Context has ${debugOutput.contextSize} keys:`, debugOutput.contextKeys);
    console.log('📋 Full Context:', fullContext);

    Object.entries(fullContext).forEach(([key, value]) => {
      console.log(`${key}:`, value);
    });

    console.groupEnd();

    console.log('Debug Context (JSON):', JSON.stringify(fullContext, null, 2));

    if (uiStateCallback) {
      uiStateCallback('complete');
    }

    return {};
  } catch (error) {
    console.error('❌ Debug method failed:', error);

    if (uiStateCallback) {
      uiStateCallback('error');
    }

    return { error: true };
  }
};
